import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LinkedInCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const accessToken = query.get('accessToken');
    const userId = query.get('userId');

    if (accessToken && userId) {
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('userId', userId);
      navigate('/home');
    } else {
      navigate('/home');
    }
  }, [navigate]);

  return <div>Loading...</div>;
};

export default LinkedInCallback;